import {SocialAuthIntegration} from '@practicegenius/domain/src/data/integrations';

// If we ever have more implementations we'll need to extract this into a different file
export type LastUsedSocialProviderManager = {
  get: () => SocialAuthIntegration | null;
  set: (provider: SocialAuthIntegration) => void;
};

const STORAGE_KEY = 'last-used-social-provider';

const getLastUsedSocialProvider = () => {
  return localStorage.getItem(STORAGE_KEY) as SocialAuthIntegration | null;
};

const setLastUsedSocialProvider = (provider: SocialAuthIntegration): void => {
  localStorage.setItem(STORAGE_KEY, provider);
};

export const localStorageLastUsedSocialProviderManager: LastUsedSocialProviderManager =
  {
    get: getLastUsedSocialProvider,
    set: setLastUsedSocialProvider,
  };
